import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ProfileDetail = lazy(async () => {
  const m = await import("@/features/supervision/components/profile-detail");
  return { default: m.ProfileDetail };
});

function ProfileDetailPage() {
  const params = useParams({ from: "/_app/supervised/$profileId" });
  return (
    <Suspense fallback={null}>
      <ProfileDetail profileId={params().profileId} />
    </Suspense>
  );
}

export const supervisedProfileRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/supervised/$profileId",
  component: ProfileDetailPage,
});
